import { api_GET, api_POST, api_PUT } from "./_api.js";

const indiceIPCA_api = {
    getList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET("IndiceIPCA")
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getVerificacaoCadastroIndiceMesAtual: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET("IndiceIPCA/VerificacaoCadastroIndiceMesAtual")
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (indiceIPCA) => {
        const promise = new Promise((resolve, reject) => {
            api_POST("IndiceIPCA", indiceIPCA)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (indiceIPCA) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT("IndiceIPCA", indiceIPCA)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    forcarSincronizacaoIBGE: () => {
        const promise = new Promise((resolve, reject) => {
            api_POST("IndiceIPCA/ForcarSincronizacaoIBGE")
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default indiceIPCA_api;